import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { adminApi, setToken, getToken } from "@/lib/auth";
import { Loader2, Sparkles } from "lucide-react";
import { Footer } from "@/components/Footer";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (getToken()) navigate("/admin/dashboard", { replace: true });
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return toast.error("Renseignez vos identifiants.");
    setLoading(true);
    try {
      const { data } = await adminApi.post("/auth/login", {
        email: email.trim(),
        password,
      });
      setToken(data.token);
      toast.success(`Bienvenue ${data.name}`);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Connexion impossible.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen flex flex-col px-6">
      <div className="oracle-bg" />
      <div className="flex-1 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative z-10 w-full max-w-md bg-white/5 backdrop-blur-2xl border border-white/10 rounded-2xl p-10"
      >
        <div className="text-center mb-10">
          <Sparkles className="text-[#C5A059] mx-auto mb-4" strokeWidth={1} size={32} />
          <span className="font-body text-[#A2A2A6] uppercase tracking-[0.35em] text-xs">
            Espace privé
          </span>
          <h1 className="font-display text-3xl tracking-tight text-[#E5E5EA] mt-2">
            Administration
          </h1>
        </div>

        <form onSubmit={submit} className="space-y-8">
          <div>
            <label className="block text-center font-body text-[#A2A2A6] text-sm mb-3">
              Identifiant
            </label>
            <input
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="oracle-input font-display text-xl w-full py-2"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="block text-center font-body text-[#A2A2A6] text-sm mb-3">
              Mot de passe
            </label>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="oracle-input font-display text-xl w-full py-2"
              autoComplete="current-password"
            />
          </div>
          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="flex items-center justify-center gap-2 w-full border border-[#C5A059]/50 text-[#C5A059] hover:bg-[#C5A059]/10 tracking-[0.2em] uppercase rounded-sm py-3.5 font-body text-sm transition-colors disabled:opacity-50"
          >
            {loading && <Loader2 className="animate-spin" size={16} />}
            Se connecter
          </button>
        </form>

        <button
          onClick={() => navigate("/")}
          className="block mx-auto mt-8 text-[#A2A2A6] hover:text-[#E5E5EA] transition-colors text-sm font-body"
        >
          Retour à l'Oracle
        </button>
      </motion.div>
      </div>
      <Footer />
    </div>
  );
}
